import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { paymentTypeInfoMap } from '../constants';
import { formatCurrency } from '../shared/formatters';
import { PolicyStatus } from '../shared/generated';
import { formatCommonDateStr } from './time';
export var calculateTheTotalPaymentAdjustmentListInfo = function calculateTheTotalPaymentAdjustmentListInfo(list) {
  var totalList = [{
    payment_type: 'total_payment_processed'
  }, {
    payment_type: 'total_refund'
  }, {
    payment_type: 'total_net_payment'
  }];
  var newList = [];
  totalList.forEach(function (item) {
    var net_premium = 0;
    var tax = 0;
    var admin_fee = 0;
    var processing_fee = 0;
    var total_premium = 0;
    list.forEach(function (aItem) {
      var canAdd = false;

      if (item.payment_type === 'total_payment_processed' && aItem.payment_type === 'payment' || item.payment_type === 'total_refund' && aItem.payment_type === 'refund' || item.payment_type === 'total_net_payment') {
        canAdd = true;
      }

      if (canAdd) {
        net_premium += aItem.net_premium;
        tax += aItem.tax;
        admin_fee += aItem.admin_fee;
        processing_fee += aItem.processing_fee;
        total_premium += aItem.total_premium;
      }
    });
    newList.push(_objectSpread(_objectSpread(_objectSpread({}, list[0]), item), {}, {
      paid_at: null,
      net_premium: net_premium,
      tax: tax,
      admin_fee: admin_fee,
      processing_fee: processing_fee,
      total_premium: total_premium
    }));
  });
  return newList;
};
export var handlePolicyPaymentAdjustmentListInfo = function handlePolicyPaymentAdjustmentListInfo(list) {
  return (list || []).map(function (item) {
    var _paymentTypeInfoMap$i;

    var paymentTypeText = (_paymentTypeInfoMap$i = paymentTypeInfoMap[item.payment_type]) === null || _paymentTypeInfoMap$i === void 0 ? void 0 : _paymentTypeInfoMap$i.label;

    if (item.operation_type === 'policy_dispute') {
      paymentTypeText = 'Refund (Dispute)';
    }

    var priceText = formatCurrency({
      amount: item.net_premium,
      currency: item.currency
    });
    var taxText = formatCurrency({
      amount: item.tax,
      currency: item.currency
    });
    var adminFeeText = formatCurrency({
      amount: item.admin_fee,
      currency: item.currency
    });
    var processingFeeText = formatCurrency({
      amount: item.processing_fee,
      currency: item.currency
    });
    var totalText = formatCurrency({
      amount: item.total_premium,
      currency: item.currency
    });
    var paymentTimeText = formatCommonDateStr(item.paid_at);
    return _objectSpread(_objectSpread({}, item), {}, {
      paymentTypeText: paymentTypeText,
      priceText: priceText,
      taxText: taxText,
      adminFeeText: adminFeeText,
      processingFeeText: processingFeeText,
      totalText: totalText,
      paymentTimeText: paymentTimeText
    });
  });
};
export var judgePolicyCanPaymentDelayReferral = function judgePolicyCanPaymentDelayReferral(policyDetailInfo) {
  return [PolicyStatus.RENEWAL_PAYMENT_DELAY_REFERRAL, PolicyStatus.RENEWAL_REFERRAL_APPROVED].includes(policyDetailInfo === null || policyDetailInfo === void 0 ? void 0 : policyDetailInfo.status);
};
export var judgePolicyCanShowMidTermAdjustment = function judgePolicyCanShowMidTermAdjustment(policyDetailInfo) {
  return [PolicyStatus.POLICY_UPDATED, PolicyStatus.POLICY_UPDATE_QUOTE, PolicyStatus.POLICY_UPDATE_QUOTE_CONFIRMED, PolicyStatus.POLICY_UPDATE_REFERRAL].includes(policyDetailInfo === null || policyDetailInfo === void 0 ? void 0 : policyDetailInfo.status);
};